module.exports = __webpack_public_path__ + "assets/media/4.89e1f17b.wav";